import axios from '@api';

import type {
  ClientCredit,
  ClientCreditsResponse,
  ClientCreditsUpdate,
  ClientSubscriptionResponse,
  SurveySubscription,
  UserCredit,
  UserCreditsResponse,
  UserSubscriptionsPage,
  UserSubscriptionsResponse,
} from './types';
import {
  transformClientCredits,
  transformClientCreditsforApi,
  transformClientSubscriptionData,
  transformUserCreditsData,
  transformUserCreditsForApi,
  transformUserSubscriptionData,
} from './utilities/helpers';

interface ReadClientUsersSubscriptionOptions {
  page?: number;
  pageSize?: number;
}

export const readClientCredits = () => {
  return axios<ClientCredit[]>({
    method: 'get',
    transformResponse: [
      (data: string) => transformClientCredits(JSON.parse(data) as ClientCreditsResponse),
    ],
    url: '/api/client/credits',
    withCredentials: true,
  });
};

export const readClientSubscription = () => {
  return axios<SurveySubscription[]>({
    method: 'get',
    transformResponse: [
      (data: string) =>
        transformClientSubscriptionData(JSON.parse(data) as ClientSubscriptionResponse[]),
    ],
    url: '/api/client/subscriptions',
    withCredentials: true,
  }).then((response) => response.data);
};

export const readClientUserCredits = () => {
  return axios<undefined | UserCredit[]>({
    method: 'get',
    transformResponse: [
      (data: string) => transformUserCreditsData(JSON.parse(data) as UserCreditsResponse),
    ],
    url: '/api/client/users/credits',
    withCredentials: true,
  });
};

export const readClientUsersSubscription = ({
  page,
  pageSize,
}: ReadClientUsersSubscriptionOptions = {}) => {
  return axios<UserSubscriptionsPage>({
    method: 'get',
    params: {
      page,
      page_size: pageSize,
    },
    transformResponse: [
      (data: string) =>
        transformUserSubscriptionData(JSON.parse(data) as UserSubscriptionsResponse),
    ],
    url: '/api/subscription/users',
    withCredentials: true,
  }).then((response) => response.data);
};

export const updateClientUserCredits = (data: UserCredit[]) => {
  return axios<undefined | UserCredit[]>({
    data: {
      users: transformUserCreditsForApi(data),
    },
    method: 'post',
    transformResponse: [
      (responseData: string) =>
        transformUserCreditsData(JSON.parse(responseData) as UserCreditsResponse),
    ],
    url: '/api/client/users/credits',
    withCredentials: true,
  });
};

export const updateClientCredits = (data: ClientCreditsUpdate) => {
  return axios<ClientCredit[]>({
    data: transformClientCreditsforApi(data),
    method: 'post',
    transformResponse: [
      (responseData: string) =>
        transformClientCredits(JSON.parse(responseData) as ClientCreditsResponse),
    ],
    url: '/api/client/credits',
    withCredentials: true,
  });
};
